<form class="c-modal c-modal--sm" name="vm.form" #mainForm="ngForm" (ngSubmit)="vm.handleModalSubmit(mainForm)" autocomplete="off" >
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p class="c-modal__title c-text c-text--xl">{{'PreVisit.Modal_Create_User.Registration_Form' | translate}}</p>
				</div>
			</div>
		</div>
		<div class="c-modal__content">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div class="c-form__group u-osb-lg">
					<label for="userPersonalCode" class="c-form__label u-osb-xs" >{{'PreVisit.Modal_Create_User.Identifier' | translate}}</label>
					<input type="text" id="userPersonalCode" name="personalCode" class="c-form__input" autocomplete="off" [(ngModel)]="vm.user.personalCode" disabled/>
				</div>
				
				<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || firstname.dirty) && firstname.invalid }">
					<label for="userFirstName" class="c-form__label u-osb-xs" >{{'PreVisit.Modal_Create_User.First_Name' | translate}}</label>
					<input type="text" id="userFirstName" name="firstname" #firstname="ngModel" class="c-form__input" autocomplete="off" [(ngModel)]="vm.user.firstname" required/>
				</div>
				
				<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || lastname.dirty) && lastname.invalid }">
					<label for="userLastName" class="c-form__label u-osb-xs" >{{'PreVisit.Modal_Create_User.Last_Name' | translate}}</label>
					<input type="text" id="userLastName" name="lastname" #lastname="ngModel" class="c-form__input" autocomplete="off" [(ngModel)]="vm.user.lastname" required/>
				</div>
				
				<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || phone.dirty) && (!vm.countryCode || phone.invalid) }">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-40 u-no-pl">
							<label for="{{ 'countryCode-' + vm.uid }}" class="c-form__label">
								{{ 'Modal.Form.Label.Country_Code' | translate }}
							</label>
							<input-autocomplete id="{{'countryCode-' + vm.uid}}"
								name="countryCode"
								[(model)]="vm.countryCode"
								[searchFn]="vm.handleCountryCodeSearch"
								[selectFn]="vm.handleCountryCodeSelect"
								[clearFn]="vm.clearCountryCodeSearch"
								[isRequired]="true"
								[minLength]="2"
								[isSmall]="true">
							</input-autocomplete>
						</div>
						<div class="o-grid__cell o-grid__cell--w-60 u-no-p">
							<label for="{{ 'phone-' + vm.uid }}" class="c-form__label">{{ 'Modal.Form.Label.Phone' | translate }}</label>
							<input id="{{ 'phone-' + vm.uid }}" name="phone" #phone="ngModel" type="tel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.user.phone" maxlength="24" pattern="^[0-9 +)(-]+$" required>
	                        <p class="c-text c-text--sm c-text--bold u-ost-xs" *ngIf="vm.countryCode?.dialCode && vm.user?.phone && vm.user?.phone?.length > 1">{{ 'Modal.Form.Label.Phone' | translate }}: {{vm.countryCode?.dialCode}} {{vm.user?.phone}}</p>
						</div>
					</div>
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="vm.submitted && !vm.countryCode">{{ 'Modal.Form.Label.Country_Code_Error_Required' | translate }}</p>
							<item-form-error *ngIf="(vm.submitted || phone.dirty) && phone.invalid" [fieldName]="'Modal.Form.Label.Phone' | translate" [error]="phone.errors"></item-form-error>
						</div>
					</div>
				</div>
				<div *ngIf="!vm.isInserterAndPatientNotServicedBySameGpOrganization">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<button id="createNewUserButton" type="submit" class="c-button c-button--s2 c-button--fit" [disabled]="vm.processing">
								{{'PreVisit.Modal_Create_User.Insert_User' | translate}}
							</button>
							<button id="cancelCreateNewUserButton" type="button" class="c-button c-button--s6 c-button--fit u-ost-md" (click)="vm.handleModalClose()" [disabled]="vm.processing">
								{{'PreVisit.Modal_Create_User.Cancel' | translate}}
							</button>
						</div>
					</div>
				</div>
				<div *ngIf="vm.isInserterAndPatientNotServicedBySameGpOrganization">
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<p class="c-text c-text--s3 u-osb-xs" >
								{{'PreVisit.Modal_Create_User.Not_Serviced_By_Same_Gp_Organization' | translate}}
							</p>
							<button id="notSameGpOrgOkButton" type="button" class="c-button c-button--s6 c-button--fit u-ost-md" (click)="vm.handleModalClose()" [disabled]="vm.processing">
								{{'Common.Ok' | translate}}
							</button>
						</div>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing"></loader-overlay>
			</div>
		</div>
	</div>
</form>
